// We already have a typedef named ConsentType
export enum ConsentEnum {
  EXPRESS = 'express',
  WRITTEN = 'written',
  STOP = 'stop'
}